<div class="card-container">
    <div class="nome-flex">
        <img src="../../../assets/quote.svg" />
             <h5>Marina Ribeiro</h5>
    </div>
    <div class="content-flex">
        <p>“O Forecast mudou o jogo para nós! Com suas ferramentas inovadoras, gerenciar nossos projetos ficou mais
            eficiente do que nunca.”</p>
    </div>
    <div class="rating-flex">
        <label>4.5/5 </label>
        <img src="../../../assets/avaliacao-star.svg" />
    </div>
</div>